export const zipcodeServerError =
  'An error occured while computing your formula. Please try again in a moment.';
